import Api from "app/services/common/Api";
import {ApiUrlUtil} from "app/utils/apiUrlUtil";
import { ReportAdminRpSearch, ReportModel } from "app/model/report/ReportModel";
import { ParticipationCount } from "app/model/rp/Re100Model";

export class ReportAdminService extends Api {
  private static service: ReportAdminService;

  public static getInstance(): ReportAdminService {
    if (!ReportAdminService.service) {
      ReportAdminService.service = new ReportAdminService();
    }
    return ReportAdminService.service;
  }

  // 전력 사용량
  public async getUsePwr(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/report/reportAdmin/complex/pwr/use/trend", search);
    return super.get<any>(url);
  }

  public async getAgg(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/report/reportAdmin/complex/pwr/use/agg", search);
    return super.get<any>(url);
  }

  public async getBzknd(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/report/reportAdmin/complex/pwr/use/bzknd", search);
    return super.get<any>(url);
  }

  public async getTmz(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/report/reportAdmin/complex/pwr/use/tmz", search);
    return super.get<any>(url);
  }

  // RE100 현황
  public async getReportDetail004(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/report/detail004", search);
    return super.get<ReportModel>(url);
  }

  public async getReportDetail005(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/report/detail005", search);
    return super.get<ReportModel>(url);
  }

  public async getReportDetail006(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_RP + "/report/detail006", search);
    return super.get<any>(url);
  }

  // 관리자 > 산단 RE100 참여 현황 기업 수
  public async getParticipationCount(search?: ReportAdminRpSearch) {
    const url = process.env.REACT_APP_URL_RP + "/report/participation/count";
    return super.get<ParticipationCount>(url, search);
  }

  public async getUseQnt(search: any) {
    const url = ApiUrlUtil.buildQueryString(process.env.REACT_APP_URL_CO + "/report/reportAdmin/complex/pwr/use", search);
    return super.get<any>(url);
  }

}